import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import toast from 'react-hot-toast';
import { AlertTriangle, Send, X } from 'lucide-react';

export default function EmergencyPage() {
  const [message, setMessage] = useState('');
  const [active, setActive] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const { data } = await api.get('/settings');
        setMessage(data.settings?.emergency_message || '');
        setActive(data.settings?.emergency_active === 'true');
      } catch (err) { console.error(err); }
      setLoading(false);
    };
    fetchSettings();
  }, []);

  const handleSend = async () => {
    try {
      await api.post('/emergency', { message, active: true });
      setActive(true);
      toast.success('Emergency message activated!');
    } catch (err) { toast.error('Failed'); }
  };

  const handleDeactivate = async () => {
    try {
      await api.post('/emergency', { message: '', active: false });
      setActive(false); setMessage('');
      toast.success('Emergency message deactivated');
    } catch (err) { toast.error('Failed'); }
  };

  if (loading) return <div className="loading-page"><span className="spinner" /></div>;

  return (
    <div className="page-content">
      <div className="page-header">
        <div>
          <h2>Emergency Broadcast</h2>
          <div className="page-header-sub">Send urgent messages to all TVs instantly</div>
        </div>
      </div>

      <div className="card card-padded" style={{ maxWidth: 600 }}>
        {active && (
          <div style={{
            padding: '12px 16px', background: 'var(--danger-soft)', border: '1px solid var(--danger)',
            borderRadius: 'var(--radius-md)', marginBottom: 20, display: 'flex', alignItems: 'center', gap: 10,
          }}>
            <AlertTriangle size={18} style={{ color: 'var(--danger)', flexShrink: 0 }} />
            <span style={{ fontSize: 14, color: 'var(--danger)', fontWeight: 500 }}>
              Emergency message is currently ACTIVE on all TVs
            </span>
          </div>
        )}

        <div className="form-group">
          <label className="form-label">Emergency Message</label>
          <textarea className="form-input" rows={4} value={message}
            onChange={e => setMessage(e.target.value)}
            placeholder="Type your emergency message here..." />
        </div>

        <div style={{ display: 'flex', gap: 10 }}>
          {!active ? (
            <button className="btn btn-danger" onClick={handleSend} disabled={!message.trim()}>
              <Send size={16} /> Broadcast to All TVs
            </button>
          ) : (
            <button className="btn btn-secondary" onClick={handleDeactivate}>
              <X size={16} /> Deactivate Emergency
            </button>
          )}
        </div>

        <p style={{ fontSize: 12, color: 'var(--text-tertiary)', marginTop: 16 }}>
          This will override all current playlists and display the message on every connected TV immediately.
          TVs will resume normal playback once deactivated.
        </p>
      </div>
    </div>
  );
}
